/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { Redirect } from "react-router-dom";
import { clearToken, getToken, setToken } from "../../../auth/token-store";
import Loader from "../../../components/Loader/loader";
import { consumeCallback, exchangeCode, startAuthorize } from "../../../auth/pkce";

export default function Authorization() {
  const access_token = getToken();
  const [isToken, setIsToken] = useState(false);
  useEffect(() => {
    if (!access_token) {
      (async () => {
        const urlparams = new URLSearchParams(window.location.search);

        if (urlparams.has("code")) {
          // IIDM-3064 T3: `state` must match the nonce this tab stored before the redirect, and
          // the verifier is single use. A mismatch (login CSRF, a replayed or foreign callback)
          // sends NO token request — the user goes back through a fresh authorize instead.
          const callback = consumeCallback(window.location.search);
          if (!callback) {
            clearToken();
            await startAuthorize();
            return;
          }
          // PKCE exchange: `code_verifier`, no client secret (public client, IIDM-3063).
          const accessToken = await exchangeCode(callback.code, callback.verifier);
          if (accessToken) {
            // IIDM-3064 T1: token store (sessionStorage); the junk `document.cookie` write
            // that followed this line is gone (audit S-15).
            setToken(accessToken);
            setIsToken(true);
          } else {
            clearToken();
            setIsToken(false);
          }
          // Plan Q2 (approved default): keep the reload while routes.tsx reads the token at mount.
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          // `startAuthorize` keeps the `payload.smart_link` write that permission-api-component
          // reads after login (unchanged); `smart_link` no longer rides on the authorize URL —
          // the SSO never read it.
          await startAuthorize(window.location.pathname);
        }
      })();
    } else {
    }
  }, []);

  return (
    <Fragment>
      {isToken && <Redirect exact from="/" to="/loading..." />}
      {!isToken && <Loader />}
    </Fragment>
  );
}
